import { storage } from '@/services/firebase'

export const downloadBlobAsFile = async (url, fileName) => {
    const response = await fetch(url)
    const blob = await response.blob()
    const objectUrl = URL.createObjectURL(blob)
    const link = window.document.createElement('a')
    link.href = objectUrl
    link.download = fileName
    link.click()
    URL.revokeObjectURL(objectUrl)
}

export const openFile = async (file, path) => {
    try {
        const storageRef = storage().ref(path)
        const documentRef = storageRef.child(file)
        let url = ''
        await documentRef
            .getDownloadURL()
            .then(res => {
                url = res
            })
            .catch(err => {
                url = ''
                err && true
            })
        setTimeout(() => {
            if (url !== '') {
                window.open(url, '_blank')
            }
        })
        return url
    } catch (error) {
        throw new Error('FILE ERROR!')
    }
}
